import React, {Component} from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import FaqStore from '../stores/FaqStore';

import ContentLoader, { Rect } from 'react-content-loader';

@observer
export default class PopupFaq extends Component {
	componentWillMount() {
		FaqStore.fetchData();
	}

	render() {
		return (
			<section id="popup-faq-nav-btn" className="popup-generic-nav-btn active">
				{ !FaqStore.loaded &&
					<div className="container-contentloader">
						<div>
							<ContentLoader height={65} speed={1} primaryColor={'#fff'} secondaryColor={'#e3e3e3'}>
					      <Rect x={20} y={30} height={20} radius={4} width={180} />
					    </ContentLoader>
						</div>

						<div>
							<ContentLoader height={65} speed={1} primaryColor={'#fff'} secondaryColor={'#e3e3e3'}>
					      <Rect x={20} y={30} height={20} radius={4} width={150} />
					    </ContentLoader>
						</div>

						<div>
							<ContentLoader height={65} speed={1} primaryColor={'#fff'} secondaryColor={'#e3e3e3'}>
					      <Rect x={20} y={30} height={20} radius={4} width={200} />
					    </ContentLoader>
						</div>
					</div>
				}

				<ul className="internal-header-menu">
					{FaqStore.sections.map((section) => {
						return (
							<li key={section.id}>
									<Link to={{
												pathname: `${this.props.match.url}/faqs/${section.id}/faq`,
												state: {
													backUrl: this.props.match.url
												}
										}}
										title={section.name}>
											<img src={require('../img/icon-plus.svg')} alt="" className="icon-plus"/>
											<img src={require('../img/icon-plus-white.svg')} alt="" className="icon-plus-white"/>
											<span>{section.name}</span>
									</Link>
							</li>
						);
					})}
				</ul>
	  	</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/PopupFaq.js